module.exports = __webpack_public_path__ + "img/login_bg.d19a3f6c.png";